import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M7 14h9v2H7v-2ZM4 9h9v2H4V9Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 8.538a.7.7 0 0 1 .7-.7h9.867a.7.7 0 0 1 .7.7v2.3a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7v-2.3Zm1.4.7v.9h8.467v-.9H4.4Zm1.333 4.361a.7.7 0 0 1 .7-.7H16.3a.7.7 0 0 1 .7.7v2.3a.7.7 0 0 1-.7.7H6.433a.7.7 0 0 1-.7-.7v-2.3Zm1.4.7v.9H15.6v-.9H7.133Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.486 3.499a.332.332 0 0 1 .474 0l1.183 1.196a.34.34 0 0 1 0 .478L7.96 6.368a.332.332 0 0 1-.474 0L6.303 5.173a.34.34 0 0 1 0-.478l1.183-1.196Zm4.554 0a.332.332 0 0 1 .474 0l1.183 1.196a.34.34 0 0 1 0 .478l-1.183 1.195a.332.332 0 0 1-.474 0l-1.183-1.195a.34.34 0 0 1 0-.478l1.183-1.196Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=TimelineIcon20.js.map